import React, { useState, useEffect, useMemo } from 'react';
import { Card, Form, Space, Input } from 'antd';

import { RadioListComponent, DataComponent, formItemLayout }from '../Common'
import { isEmpty } from 'script/common';

const RedisMode = ({t, props, optionList, settingKey, settingData, onSave, alertMessage, onDataLoad}) => {
	const [option, setOption] = useState(() => {
		let value = optionList[0]

		optionList.map(opt => {
			const dataKey = opt.value
			const dataValue = isEmpty(settingData[dataKey]) ? false : settingData[dataKey].value
			if (dataValue === true)  {
				value = opt
			}
		})
		
		return value
	});

	const initialValues = {
		['option']: option.value,
		['data']: settingData
	}

	const onFinish = (e) => {
		let isSingle = true;
		let mode = option.value;
		let nodes = null;

		if (mode === 'none') {
			onSave(isSingle, mode, nodes)
		} else {
			isSingle = false;
			let defaultValue = null
			let initValue = null
			let setValue = null

			try {
				defaultValue = initialValues.data[option.nodes].default
				initValue = initialValues.data[option.nodes].value
				setValue = e.data[option.nodes].value
			} catch (error) {

			}
			
			if (initValue !== setValue) {
				nodes = (defaultValue === setValue) ? null : setValue
			}

			if (!isEmpty(nodes)) onSave(isSingle, mode, nodes)
		}
	}

	const [form] = Form.useForm()
	useEffect(() => form.resetFields, [initialValues])

	return (
		<Form form={form} {...formItemLayout} onFinish={onFinish} initialValues={initialValues}>
			<Card title={t(settingKey.key)} key={settingKey.key} style={{ margin: 20 }}>
				<RadioListComponent
					t={t}
					option={option}
					optionList={optionList}
					setOption={setOption}
				/>
				<DataComponent nodes={option.nodes}/>				
				<Space style={{ float: 'right', margin: 20 }}>
					<button className="btn_text_b">{t('user.account.save')}</button>
				</Space>
			</Card>
		</Form>
	)
}

export default RedisMode